<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            Department of Production Planning/ ແຈ້ງເຕືອນກຳນົດການຜະລິດ
            
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid==3" >
        <b-tab-item label="ເຕືອນແລ້ວ ທີ່ຕັ້ງຄ່າແລ້ວ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການ ເຕືອນແລ້ວ ທີ່ຕັ້ງຄ່າແລ້ວ">
              </b-field>
              <b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຕັ້ງຄ່າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີແຈ້ງ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຜະລິດ
                      </th>
                      <th class="has-text-left " width="20%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ປະເພດຜະລິດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດການຜະລິດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊາວກະສິກອນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in plantnotisetup"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SETUPDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.NOTIDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.EFFECTDATE) }}
                      </td>
                      <td class="has-text-left">
                        {{ data.PRODUCTNAME }} {{ data.QUANTITY }} {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.PRODUCTIONTYPE_TITLE }}
                      </td>
                      <td>
                        {{ data.PRODUCTIONACTIONID }}
                      </td>
                      <td>
                        {{ data.FARMNAME }}<br>{{ data.FARMERID}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ແຈ້ງເຕືອນ ທີ່ສົ່ງອອກໄປແລ້ວ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການ ແຈ້ງເຕືອນ ທີ່ສົ່ງອອກໄປແລ້ວ">
              </b-field>
              <b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຕັ້ງຄ່າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີແຈ້ງ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຜະລິດ
                      </th>
                      <th class="has-text-left " width="20%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ປະເພດຜະລິດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດການຜະລິດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊາວກະສິກອນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in plantnotisend"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SETUPDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.NOTIDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.EFFECTDATE) }}
                      </td>
                      <td class="has-text-left">
                        {{ data.PRODUCTNAME }} {{ data.QUANTITY }} {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.PRODUCTIONTYPE_TITLE }}
                      </td>
                      <td>
                        {{ data.PRODUCTIONACTIONID }}
                      </td>
                      <td>
                        {{ data.FARMNAME }}<br>{{ data.FARMERID}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ແຈ້ງເຕືອນ ທີ່ຮັບຮູ້ແລ້ວ">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການ ແຈ້ງເຕືອນ ທີ່ຮັບຮູ້ແລ້ວ">
              </b-field>
              <b-field>
                <table
                  class="table is-fullwidth is-narrow is-small"
                >
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="2%">#</th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຕັ້ງຄ່າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີແຈ້ງ
                      </th>
                      <th class="has-text-left " width="10%">
                        ວັນທີຜະລິດ
                      </th>
                      <th class="has-text-left " width="20%">
                        ສິນຄ້າ
                      </th>
                      <th class="has-text-left " width="10%">
                        ປະເພດຜະລິດ
                      </th>
                      <th class="has-text-left " width="10%">
                        ລະຫັດການຜະລິດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ຊາວກະສິກອນ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in plantnotiknown"
                      :key="data.ID"
                    >
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ dateFormatter(data.SETUPDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.NOTIDATE) }}
                      </td>
                      <td>
                        {{  dateFormatter(data.EFFECTDATE) }}
                      </td>
                      <td class="has-text-left">
                        {{ data.PRODUCTNAME }} {{ data.QUANTITY }} {{ data.UNIT }}
                      </td>
                      <td>
                        {{ data.PRODUCTIONTYPE_TITLE }}
                      </td>
                      <td>
                        {{ data.PRODUCTIONACTIONID }}
                      </td>
                      <td>
                        {{ data.FARMNAME }}<br>{{ data.FARMERID}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
    roleid: null,
    userName: null,
    activeTab: 0,
    plantnotisetup: [],
    plantnotisend: [],
    plantnotiknown: [],
 
    };
  },
  methods: {
    getPlantNoti(){
      RestAPI.getPlantNoti(1,this.userProvinceID)
        .then(res => {
          console.log("res:" + JSON.stringify(res.data))
          this.plantnotisetup = res.data.plantnotisetup;
          this.plantnotisend = res.data.plantnotisend;
          this.plantnotiknown = res.data.plantnotiknown;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID 
    this.getPlantNoti();

  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.section-title{
  margin-top:10px;
  font-size: 20;
  font-weight: bold;
  text-decoration: underline;
}
.asterisk{
  color: red;
}
</style>